import { PageTransition } from "@steveeeie/react-page-transition";
import { ConnectedRouter } from "connected-react-router";
import React, { Component, Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import Loading from "./components/Loading";
import App from "./layouts/App";
import Login from "./layouts/Login";
import NotFound from "./pages/NotFound";
import { routes } from "./router";
import { browserHistory, store } from "./store/createStore";

import { STORAGE_KEYS } from "shared/constant";
import "./root.scss";

class Root extends Component {
  render() {
    let auth = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const isLogin = !!auth && window.location.pathname !== "/";
    return (
      <Provider store={store}>
        <Suspense fallback={<Loading />}>
          <ConnectedRouter history={browserHistory}>
            <Switch>
              <Route exact path="/login" component={Login} />
              {/* <Route exact path="/forget" component={ForgetPw} /> */}
              {/* <Route path="/user/reset/:token/" component={ResetForgetPw} /> */}
              {isLogin ? (
                <App>
                  <Route
                    render={({ location }) => {
                      return (
                        <PageTransition preset="moveToLeftFromRight" transitionKey={location.pathname}>
                          <Switch location={location}>
                            {(Object.entries(routes) || []).map((route) => {
                              const { path, extraProps = {} } = route[1];
                              if (!path) return undefined;
                              const key = route[0];
                              const Component = lazy(() => import(`./pages/${key}`));
                              return (
                                <Route
                                  key={key}
                                  path={path}
                                  render={(props) =>
                                    React.createElement(Component, {
                                      ...props,
                                      ...extraProps
                                    })
                                  }
                                />
                              );
                            })}
                            <Route path="/net-zero/*" exact={true} component={NotFound} />
                          </Switch>
                        </PageTransition>
                      );
                    }}
                  />
                </App>
              ) : (
                <Redirect to="/login" />
              )}
            </Switch>
          </ConnectedRouter>
        </Suspense>
      </Provider>
    );
  }
}

export default Root;
